/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import ConfirmGoodsVatRateAPI from '@/api/ConfirmGoodsVatRateAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';
import { MSEnum } from '@/common/enumeration';
export default {
	/**
	 * Lấy danh sách
	 */
	loadListDataAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: `${ConfirmGoodsVatRateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}`,
			data: payload
		});
		if (res.Success && res.Data) {
			context.commit('updateConfirmGoodsVatRates', res.Data);
			return res.Data;
		}
		return null;
	},

	getTotalPageAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: `${ConfirmGoodsVatRateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/total`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalPage', res.Data);
		}
		return 0;
	},

	deleteConfirmGoodsVatRate: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: `${ConfirmGoodsVatRateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/delete`,
			data: payload
		});
		let result = res && res.Data;
		if (result) {
			context.commit('updateDeleteConfirmGoodsVatRate');
		}
		return result;
	},

	updateConfirmGoodsVatRate: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: `${ConfirmGoodsVatRateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}`,
			data: payload
		});
		return res && res.Data;
	},

	getConfirmGoodsVatRate: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: `${ConfirmGoodsVatRateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/datadetail`,
			data: payload
		});

		if (res && res.Success && res.Data) {
			context.commit('updateConfirmGoodsVatRate', res.Data);
			return res.Data;
		} else {
			context.commit('updateConfirmGoodsVatRate', {});
		}
		return {};
	},

	insertConfirmGoodsVatRate: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: `${ConfirmGoodsVatRateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/insert`,
			data: payload
		});
		return res && res.Success && res.Data;
	},

	updateItemInvoice: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: `${ConfirmGoodsVatRateAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/updateitem`,
			data: payload
		});
		return res && res.Success && res.Data;
	}
};
